/**
 * Creamy Loots — PDP JS · Theme-brutalism
 * Maneja: variantes, galería, ATC, sticky bar
 */
(function () {
  'use strict';

  /* ── UTILIDADES ─────────────────────────────────────────────────────── */

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return [...(ctx || document).querySelectorAll(sel)]; }

  /* ── GALERÍA ─────────────────────────────────────────────────────────── */

  function initGallery(sectionId) {
    const thumbs  = qsa(`#cl-pdp-thumbs-${sectionId} .cl-pdp__thumb`);
    const mainImg = qs(`#cl-pdp-main-img-${sectionId}`);
    if (!mainImg || !thumbs.length) return;

    function swapImage(src, srcset, alt) {
      mainImg.classList.add('is-fading');
      // Wait for fade-out transition (150ms) to finish before swapping src
      setTimeout(() => {
        mainImg.src    = src;
        if (srcset) mainImg.srcset = srcset;
        if (alt)    mainImg.alt    = alt;
        mainImg.classList.remove('is-fading');
        const stickyImg = qs(`#cl-sticky-img-${sectionId}`);
        if (stickyImg) stickyImg.src = src;
      }, 160);
    }

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        swapImage(thumb.dataset.imgSrc, thumb.dataset.imgSrcset || '', thumb.dataset.imgAlt || '');
      });
    });
  }

  /* ── VARIANTES ──────────────────────────────────────────────────────── */

  function initVariants(sectionId) {
    const variantsEl = qs(`#cl-pdp-variants-${sectionId}`);
    if (!variantsEl) return;

    const variants = JSON.parse(variantsEl.textContent);
    const form     = qs(`#cl-pdp-form-${sectionId}`);
    if (!form) return;

    // Estado actual de opciones seleccionadas
    const selectedOpts = {};
    // Leer el estado inicial desde chips is-active
    qsa('[data-opt-pos]', form).forEach(chip => {
      if (chip.classList.contains('is-active')) {
        selectedOpts[chip.dataset.optPos] = chip.dataset.value;
      }
    });

    function findVariant() {
      return variants.find(v => {
        return Object.entries(selectedOpts).every(([pos, val]) => {
          const key = `option${pos}`;
          return v[key] === val;
        });
      }) || null;
    }

    function updateVariant(variant) {
      if (!variant) return;

      // Actualizar input hidden
      const idInput = qs(`#cl-pdp-variant-id-${sectionId}`);
      if (idInput) idInput.value = variant.id;

      // Actualizar precio
      const priceRow = qs(`#cl-pdp-price-${sectionId}`);
      if (priceRow) {
        const fmt = n => {
          const v = (n / 100).toFixed(0);
          return '$' + parseInt(v).toLocaleString('es-CO');
        };
        if (variant.compare_at_price > variant.price) {
          const disc = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          priceRow.innerHTML = `
            <span class="cl-pdp__price cl-pdp__price--sale">${fmt(variant.price)}</span>
            <span class="cl-pdp__price--compare">${fmt(variant.compare_at_price)}</span>
            <span class="cl-pdp__price-badge">-${disc}%</span>`;
        } else {
          priceRow.innerHTML = `<span class="cl-pdp__price">${fmt(variant.price)}</span>`;
        }
      }

      // Actualizar imagen si la variante tiene featured image
      if (variant.featured_image) {
        const imgUrl  = variant.featured_image.src;
        const mainImg = qs(`#cl-pdp-main-img-${sectionId}`);
        if (mainImg) {
          mainImg.classList.add('is-fading');
          setTimeout(() => {
            mainImg.src = imgUrl;
            mainImg.classList.remove('is-fading');
            const stickyImg = qs(`#cl-sticky-img-${sectionId}`);
            if (stickyImg) stickyImg.src = imgUrl;
          }, 160);
          // Activar thumbnail correspondiente
          const thumbs = qsa(`#cl-pdp-thumbs-${sectionId} .cl-pdp__thumb`);
          thumbs.forEach(t => {
            const match = t.dataset.imgSrc === imgUrl ||
                          (t.dataset.imgSrc || '').includes(String(variant.featured_image.id));
            t.classList.toggle('is-active', match);
          });
        }
      }

      // Actualizar ATC button
      const atcBtn = qs(`#cl-pdp-atc-${sectionId}`);
      const atcIdle = atcBtn?.querySelector('.cl-pdp__atc-idle');
      if (atcBtn) {
        if (variant.available) {
          atcBtn.disabled = false;
          if (atcIdle) atcIdle.textContent = 'AGREGAR AL CARRITO →';
        } else {
          atcBtn.disabled = true;
          if (atcIdle) atcIdle.textContent = 'AGOTADO';
        }
      }

      // Actualizar urgencia
      const urgencyEl = qs(`#cl-pdp-urgency-${sectionId}`);
      if (urgencyEl) {
        if (variant.inventory_management === 'shopify' &&
            variant.inventory_quantity > 0 &&
            variant.inventory_quantity <= 5) {
          urgencyEl.innerHTML = `<div class="cl-pdp__urgency">
            <span class="cl-pdp__urgency__dot"></span>
            ¡SOLO QUEDAN ${variant.inventory_quantity} UNIDADES!
          </div>`;
        } else if (variant.available) {
          urgencyEl.innerHTML = `<div class="cl-pdp__urgency cl-pdp__urgency--ok">
            <span class="cl-pdp__urgency__dot"></span>
            EN STOCK · ENVÍO EN 72H
          </div>`;
        } else {
          urgencyEl.innerHTML = '';
        }
      }

      // Sincronizar precio en sticky
      updateStickyPrice(variant);
    }

    function updateStickyPrice(variant) {
      const priceEl = qs(`#cl-sticky-price-${sectionId} .cl-sticky-atc__price-current`);
      const compareEl = qs(`#cl-sticky-price-${sectionId} .cl-sticky-atc__price-compare`);
      if (!priceEl) return;
      const fmt = n => '$' + parseInt((n / 100).toFixed(0)).toLocaleString('es-CO');
      priceEl.textContent = fmt(variant.price);
      if (compareEl) {
        if (variant.compare_at_price > variant.price) {
          compareEl.textContent = fmt(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
    }

    // Chips en el formulario principal
    qsa('.cl-pdp__chip', form).forEach(chip => {
      chip.addEventListener('click', () => {
        if (chip.classList.contains('is-disabled')) return;
        const pos = chip.dataset.optPos;
        const val = chip.dataset.value;

        // Activar chip
        qsa(`.cl-pdp__chip[data-opt-pos="${pos}"]`, form).forEach(c => {
          c.classList.toggle('is-active', c === chip);
          c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
          if (c === chip) c.style.padding = '';
        });

        // Actualizar label de valor seleccionado
        const labelVal = qs(`#cl-pdp-opt-val-${sectionId}-${pos}`);
        if (labelVal) labelVal.textContent = val;

        selectedOpts[pos] = val;

        // Sincronizar chips del sticky
        syncStickyChips(pos, val, sectionId);

        // Encontrar variante y actualizar
        const v = findVariant();
        updateVariant(v);
      });
    });

    return { selectedOpts, findVariant, updateVariant };
  }

  /* ── SYNC STICKY CHIPS ──────────────────────────────────────────────── */

  function syncStickyChips(pos, val, sectionId) {
    qsa(`#cl-sticky-atc-${sectionId} .cl-sticky-atc__chip[data-opt-pos="${pos}"]`).forEach(c => {
      const active = c.dataset.value === val;
      c.classList.toggle('is-active', active);
      c.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  /* ── ATC FORM ───────────────────────────────────────────────────────── */

  function initATC(sectionId) {
    const form   = qs(`#cl-pdp-form-${sectionId}`);
    const atcBtn = qs(`#cl-pdp-atc-${sectionId}`);
    if (!form || !atcBtn) return;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (atcBtn.disabled) return;

      const idle    = atcBtn.querySelector('.cl-pdp__atc-idle');
      const adding  = atcBtn.querySelector('.cl-pdp__atc-adding');
      const done    = atcBtn.querySelector('.cl-pdp__atc-done');

      atcBtn.classList.add('is-adding');
      idle.hidden = true;
      adding.hidden = false;
      adding.removeAttribute('aria-hidden');

      const formData = new FormData(form);

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        if (res.ok) {
          adding.hidden = true;
          done.hidden = false;
          done.removeAttribute('aria-hidden');
          atcBtn.classList.remove('is-adding');
          atcBtn.classList.add('is-done');

          // Disparar evento para actualizar el carrito
          document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true }));
          updateCartCount();

          setTimeout(() => {
            done.hidden = true;
            done.setAttribute('aria-hidden', 'true');
            idle.hidden = false;
            atcBtn.classList.remove('is-done');
          }, 2500);
        } else {
          throw new Error('Error al agregar');
        }
      } catch {
        adding.hidden = true;
        idle.hidden = false;
        atcBtn.classList.remove('is-adding');
        atcBtn.style.borderColor = 'var(--cl-warn)';
        atcBtn.querySelector('.cl-pdp__atc-idle').textContent = 'ERROR — INTENTA DE NUEVO';
        setTimeout(() => {
          atcBtn.style.borderColor = '';
          atcBtn.querySelector('.cl-pdp__atc-idle').textContent = 'AGREGAR AL CARRITO →';
        }, 3000);
      }
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        // Actualizar contador del header si existe
        qsa('[data-cart-count], .cl-header__cart-count').forEach(el => {
          el.textContent = cart.item_count;
        });
      })
      .catch(() => {});
  }

  /* ── CANTIDAD ───────────────────────────────────────────────────────── */

  function initQty(sectionId) {
    const wrap = qs(`#cl-pdp-qty-wrap-${sectionId}`);
    if (!wrap) return;
    const input = wrap.querySelector('.cl-pdp__qty-input');
    if (!input) return;

    wrap.querySelectorAll('.cl-pdp__qty-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const delta   = btn.dataset.action === 'minus' ? -1 : 1;
        const current = parseInt(input.value, 10) || 1;
        input.value   = Math.max(1, Math.min(99, current + delta));
      });
    });

    input.addEventListener('change', () => {
      const v = parseInt(input.value, 10);
      if (isNaN(v) || v < 1) input.value = 1;
      if (v > 99) input.value = 99;
    });
  }

  /* ── STICKY BAR ─────────────────────────────────────────────────────── */

  function initStickyBar(sectionId) {
    const bar     = qs(`#cl-sticky-atc-${sectionId}`);
    const mainBtn = qs(`#cl-pdp-atc-${sectionId}`);
    if (!bar || !mainBtn) return;

    // Mover al body para evitar stacking context
    document.body.appendChild(bar);

    // Observer para mostrar/ocultar
    const observer = new IntersectionObserver(
      ([entry]) => {
        bar.classList.toggle('cl-sticky-atc--visible', !entry.isIntersecting);
        bar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
      },
      { threshold: 0.1 }
    );
    observer.observe(mainBtn);

    // Chips del sticky → sincronizar con main form
    qsa('.cl-sticky-atc__chip', bar).forEach(chip => {
      chip.addEventListener('click', () => {
        if (chip.classList.contains('is-disabled')) return;
        const pos = chip.dataset.optPos;
        const val = chip.dataset.value;

        // Clic en el chip correspondiente del form principal
        const mainChip = qs(
          `#cl-pdp-form-${sectionId} .cl-pdp__chip[data-opt-pos="${pos}"][data-value="${CSS.escape(val)}"]`
        );
        if (mainChip && !mainChip.classList.contains('is-active')) {
          mainChip.click();
        }
      });
    });

    // Botón sticky → clic en el form principal
    const stickyBtn = qs(`#cl-sticky-btn-${sectionId}`);
    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => {
        const mainAtc = qs(`#cl-pdp-atc-${sectionId}`);
        if (mainAtc?.disabled) {
          bar.classList.add('cl-sticky-atc--shake');
          setTimeout(() => bar.classList.remove('cl-sticky-atc--shake'), 500);
          return;
        }

        const idle    = stickyBtn.querySelector('.cl-sticky-atc__btn-idle');
        const loading = stickyBtn.querySelector('.cl-sticky-atc__btn-loading');
        const done    = stickyBtn.querySelector('.cl-sticky-atc__btn-done');

        idle.hidden = true;
        loading.hidden = false;
        loading.removeAttribute('aria-hidden');

        // Clic en el botón principal (que dispara el fetch)
        mainAtc?.click();

        const onDone = () => {
          loading.hidden = true;
          done.hidden = false;
          done.removeAttribute('aria-hidden');
          document.removeEventListener('cart:add', onDone);
          setTimeout(() => {
            done.hidden = true;
            done.setAttribute('aria-hidden', 'true');
            idle.hidden = false;
          }, 2000);
        };
        document.addEventListener('cart:add', onDone, { once: true });

        // Fallback si no dispara cart:add
        setTimeout(() => {
          if (!loading.hidden) {
            loading.hidden = true;
            idle.hidden = false;
          }
        }, 5000);
      });
    }
  }

  /* ── INIT ───────────────────────────────────────────────────────────── */

  function initSection(el) {
    const id = el.dataset.section;
    initGallery(id);
    initVariants(id);
    initATC(id);
    initQty(id);
    initStickyBar(id);
  }

  function init() {
    document.querySelectorAll('.cl-pdp[data-section]').forEach(initSection);
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor: re-init when a section is loaded/reloaded
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.cl-pdp[data-section]').forEach(initSection);
  });

})();
